<div class="risk-assessment-container">
  <div class="header-section">
    <h1>化學品風險評估</h1>
    <div class="view-toggle">
      <button [class.active]="viewMode === 'chemical'" (click)="switchViewMode('chemical')">
        <i class="fas fa-flask"></i> 依化學品查看
      </button>
      <button [class.active]="viewMode === 'department'" (click)="switchViewMode('department')">
        <i class="fas fa-building"></i> 依部門查看
      </button>
      <button [class.active]="viewMode === 'method'" (click)="switchViewMode('method')">
        <i class="fas fa-tasks"></i> 依評估方法查看
      </button>
    </div>
    <div class="action-buttons">
      <button class="add-assessment-btn" (click)="openAssessmentModal()">
        <i class="fas fa-plus"></i> 新增評估
      </button>
    </div>
  </div>

  <!-- 風險概覽圖表 -->
  <div class="chart-section">
    <div class="chart-container">
      <div id="riskOverviewChart" class="chart-element"></div>
    </div>
  </div>

  <!-- 風險評估列表 -->
  <div class="assessment-list-section">
    <h2>評估結果列表</h2>

    <div class="filter-section">
      <div class="filter-group">
        <label for="chemical-filter">化學品</label>
        <select id="chemical-filter" [(ngModel)]="selectedChemicalId">
          <option value="">全部化學品</option>
          <option *ngFor="let chemical of chemicals" [value]="chemical.id">
            {{chemical.chineseName}} ({{chemical.partNumber}})
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="department-filter">部門</label>
        <select id="department-filter" [(ngModel)]="selectedDepartmentId">
          <option value="">全部部門</option>
          <option *ngFor="let dept of departments" [value]="dept.id">
            {{dept.name}}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="method-filter">評估方法</label>
        <select id="method-filter" [(ngModel)]="selectedMethodId">
          <option value="">全部方法</option>
          <option *ngFor="let method of assessmentMethods" [value]="method.id">
            {{method.name}}
          </option>
        </select>
      </div>
    </div>

    <table class="assessment-table">
      <thead>
        <tr>
          <th>日期</th>
          <th>化學品</th>
          <th>部門</th>
          <th>評估方法</th>
          <th>風險分數</th>
          <th>風險等級</th>
          <th>評估者</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of assessmentResults | filterResults:selectedChemicalId:selectedDepartmentId:selectedMethodId"
            [class.high-risk]="result.riskScore >= 70"
            [class.medium-risk]="result.riskScore >= 40 && result.riskScore < 70"
            [class.low-risk]="result.riskScore < 40">
          <td>{{result.date}}</td>
          <td>{{getChemicalName(result.chemicalId)}}</td>
          <td>{{getDepartmentName(result.departmentId)}}</td>
          <td>{{getMethodName(result.methodId)}}</td>
          <td>
            <div class="risk-score" [style.background-color]="getRiskColor(result.riskScore)">
              {{result.riskScore}}
            </div>
          </td>
          <td>{{result.riskLevel}}</td>
          <td>{{result.assessedBy}}</td>
          <td>
            <button class="view-btn" (click)="viewAssessmentDetail(result)">
              <i class="fas fa-eye"></i> 查看
            </button>
          </td>
        </tr>
        <tr *ngIf="(assessmentResults | filterResults:selectedChemicalId:selectedDepartmentId:selectedMethodId).length === 0">
          <td colspan="8" class="no-data">沒有找到評估記錄</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- 新增評估模態框 -->
  <div class="modal-overlay" *ngIf="showAssessmentModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3>新增風險評估</h3>
        <button class="close-btn" (click)="closeAssessmentModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="error-message" *ngIf="error">{{error}}</div>

        <div class="form-group">
          <label for="assessment-chemical">選擇化學品</label>
          <select id="assessment-chemical" [(ngModel)]="newAssessment.chemicalId" required>
            <option value="">-- 請選擇化學品 --</option>
            <option *ngFor="let chemical of chemicals" [value]="chemical.id">
              {{chemical.chineseName}} ({{chemical.partNumber}})
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="assessment-department">選擇部門</label>
          <select id="assessment-department" [(ngModel)]="newAssessment.departmentId" required>
            <option value="">-- 請選擇部門 --</option>
            <option *ngFor="let dept of departments" [value]="dept.id">
              {{dept.name}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="assessment-method">選擇評估方法</label>
          <select id="assessment-method" [(ngModel)]="newAssessment.methodId" (change)="onMethodChange()" required>
            <option value="">-- 請選擇評估方法 --</option>
            <option *ngFor="let method of assessmentMethods" [value]="method.id">
              {{method.name}}
            </option>
          </select>
        </div>

        <!-- CCB方法參數 -->
        <div *ngIf="newAssessment.methodId === 'ccb'" class="method-parameters">
          <h4>CCB方法參數</h4>

          <div class="form-group">
            <label for="hazardFactor">危害因子 (1-10)</label>
            <input type="number" id="hazardFactor" [(ngModel)]="newAssessment.parameters['hazardFactor']" min="1" max="10" required>
            <div class="parameter-description">化學品固有危害屬性評分，數值越高代表危害越大</div>
          </div>

          <div class="form-group">
            <label for="exposureFactor">暴露因子 (1-10)</label>
            <input type="number" id="exposureFactor" [(ngModel)]="newAssessment.parameters['exposureFactor']" min="1" max="10" required>
            <div class="parameter-description">暴露頻率和時間評分，數值越高代表暴露越嚴重</div>
          </div>

          <div class="form-group">
            <label for="amountFactor">使用量因子 (1-10)</label>
            <input type="number" id="amountFactor" [(ngModel)]="newAssessment.parameters['amountFactor']" min="1" max="10" required>
            <div class="parameter-description">化學品使用量評分，數值越高代表使用量越大</div>
          </div>

          <div class="form-group">
            <label for="controlFactor">控制因子 (0.1-1)</label>
            <input type="number" id="controlFactor" [(ngModel)]="newAssessment.parameters['controlFactor']" min="0.1" max="1" step="0.1" required>
            <div class="parameter-description">風險控制措施的有效性，數值越低代表控制越佳</div>
          </div>
        </div>

      <!-- 95百分位方法參數 -->
<div *ngIf="newAssessment.methodId === '95percentile'" class="method-parameters">
  <h4>95百分位方法參數</h4>

  <div class="form-group">
    <label for="chemConcentration">化學品濃度 (%)</label>
    <input type="number" id="chemConcentration" [(ngModel)]="newAssessment.parameters['chemConcentration']" min="0" max="100" required>
  </div>

  <div class="form-group">
    <label for="handlingDuration">每次處理時間 (小時)</label>
    <input type="number" id="handlingDuration" [(ngModel)]="newAssessment.parameters['handlingDuration']" min="0" max="24" required>
  </div>

  <div class="form-group">
    <label for="handlingFrequency">處理頻率 (次/週)</label>
    <input type="number" id="handlingFrequency" [(ngModel)]="newAssessment.parameters['handlingFrequency']" min="0" max="100" required>
  </div>

  <div class="form-group">
    <label for="temperature">使用溫度 (°C)</label>
    <input type="number" id="temperature" [(ngModel)]="newAssessment.parameters['temperature']" required>
  </div>

  <div class="form-group">
    <label for="volatility">揮發性 (1-10)</label>
    <input type="number" id="volatility" [(ngModel)]="newAssessment.parameters['volatility']" min="1" max="10" required>
    <div class="parameter-description">數值越高代表揮發性越大</div>
  </div>

  <div class="form-group">
    <label for="protectionFactor">防護因子 (0.1-1)</label>
    <input type="number" id="protectionFactor" [(ngModel)]="newAssessment.parameters['protectionFactor']" min="0.1" max="1" step="0.1" required>
    <div class="parameter-description">數值越低代表防護效果越好</div>
  </div>
</div>

<!-- Create-Simple方法參數 -->
<div *ngIf="newAssessment.methodId === 'create-simple'" class="method-parameters">
  <h4>Create-Simple方法參數</h4>

  <div class="form-group">
    <label for="hazardClass">GHS危害分類</label>
    <select id="hazardClass" [(ngModel)]="newAssessment.parameters['hazardClass']" required>
      <option value="">請選擇危害分類</option>
      <option value="A">A - 最危險 (如致癌物)</option>
      <option value="B">B - 高危險 (如急毒性物質)</option>
      <option value="C">C - 中等危險 (如腐蝕性物質)</option>
      <option value="D">D - 低危險 (如刺激性物質)</option>
      <option value="E">E - 最小危險 (如無害物質)</option>
    </select>
  </div>

  <div class="form-group">
    <label for="usageAmount">使用量 (公斤/天)</label>
    <input type="number" id="usageAmount" [(ngModel)]="newAssessment.parameters['usageAmount']" min="0" required>
  </div>

  <div class="form-group">
    <label for="dustiness">粉塵產生程度 (1-10)</label>
    <input type="number" id="dustiness" [(ngModel)]="newAssessment.parameters['dustiness']" min="1" max="10" required>
    <div class="parameter-description">數值越高代表產生粉塵越多</div>
  </div>

  <div class="form-group">
    <label for="ventilationLevel">通風程度 (1-10)</label>
    <input type="number" id="ventilationLevel" [(ngModel)]="newAssessment.parameters['ventilationLevel']" min="1" max="10" required>
    <div class="parameter-description">數值越高代表通風越好</div>
  </div>

  <div class="form-group">
    <label for="controlMeasures">控制措施 (1-10)</label>
    <input type="number" id="controlMeasures" [(ngModel)]="newAssessment.parameters['controlMeasures']" min="1" max="10" required>
    <div class="parameter-description">數值越高代表控制措施越完善</div>
  </div>
</div>

        <div class="form-group">
          <label for="assessment-notes">備註</label>
          <textarea id="assessment-notes" [(ngModel)]="newAssessment.notes" rows="3"></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" (click)="closeAssessmentModal()">取消</button>
        <button class="submit-btn" (click)="submitAssessment()">提交評估</button>
      </div>
    </div>
  </div>

  <!-- 評估結果詳情模態框 -->
  <div class="modal-overlay" *ngIf="showResultDetailModal">
    <div class="modal-container detail-modal">
      <div class="modal-header">
        <h3>風險評估詳情</h3>
        <button class="close-btn" (click)="closeResultDetailModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body" *ngIf="selectedResult">
        <div class="result-header">
          <h4>{{getChemicalName(selectedResult.chemicalId)}} - {{getDepartmentName(selectedResult.departmentId)}}</h4>
          <div class="result-meta">
            <div>評估日期：{{selectedResult.date}}</div>
            <div>評估者：{{selectedResult.assessedBy}}</div>
            <div>評估方法：{{getMethodName(selectedResult.methodId)}}</div>
          </div>
        </div>

        <div class="risk-summary">
          <div class="risk-score-large" [style.background-color]="getRiskColor(selectedResult.riskScore)">
            {{selectedResult.riskScore}}
          </div>
          <div class="risk-level-info">
            <h5>風險等級: {{selectedResult.riskLevel}}</h5>
            <p *ngIf="selectedResult.riskScore >= 70">
              此化學品在該部門的使用情況存在高風險，需要立即採取措施降低風險。
            </p>
            <p *ngIf="selectedResult.riskScore >= 40 && selectedResult.riskScore < 70">
              此化學品在該部門的使用情況存在中等風險，應實施適當的控制措施。
            </p>
            <p *ngIf="selectedResult.riskScore < 40">
              此化學品在該部門的使用情況風險較低，但仍需遵循安全操作規程。
            </p>
          </div>
        </div>

        <div class="parameter-list">
          <h5>評估參數</h5>
          <table class="parameters-table">
            <tbody>
              <tr *ngFor="let param of getMethodParameters(selectedResult.methodId); let i = index">
                <td>{{param.name}}</td>
                <td>{{selectedResult.parameters[param.id]}} {{param.unit || ''}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="recommendations">
          <h5>建議措施</h5>
          <ul>
            <li *ngFor="let recommendation of generateRecommendations(selectedResult)">
              {{recommendation}}
            </li>
          </ul>
        </div>

        <div class="notes-section" *ngIf="selectedResult.notes">
          <h5>備註</h5>
          <p>{{selectedResult.notes}}</p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="close-btn" (click)="closeResultDetailModal()">關閉</button>
        <button class="print-btn">
          <i class="fas fa-print"></i> 列印評估報告
        </button>
      </div>
    </div>
  </div>

  <!-- 載入指示器 -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner"></div>
    <span>載入中...</span>
  </div>
</div>
